"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BulkSelectionModel", {
    enumerable: true,
    get: function() {
        return BulkSelectionModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const BulkSelectionModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    created_by: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    type: _zod.z.enum([
        "goal",
        "employee"
    ]),
    object_ids: _zod.z.array(_zod.z.instanceof(_bson.ObjectId))
});
